{
  "common.loading": "Loading...",
  "common.error": "Something went wrong",
  "common.retry": "Try Again",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.post": "Post",
  "common.follow": "Follow",
  "common.following": "Following",
  "common.followers": "followers",
  "common.likes": "likes",
  "common.posts": "posts",
  "common.signOut": "Sign Out",

  "feed.forYou": "For You",
  "feed.following": "Following",
  "feed.whatsOnYourMind": "What's on your mind?",
  "feed.noPostsYet": "No posts yet",
  "feed.trending": "Trending on Scroll",

  "compose.placeholder": "What's happening?",
  "compose.posting": "Posting...",
  "compose.charLimit": "{count}/{max}",

  "profile.editProfile": "Edit Profile",
  "profile.message": "Message",
  "profile.noPostsYet": "No posts yet",
  "profile.noVideosYet": "No videos yet",
  "profile.posts": "Posts",
  "profile.videos": "Videos",

  "bookmarks.title": "Bookmarks",
  "bookmarks.empty": "No bookmarks yet",
  "bookmarks.emptyHint": "Save posts for later by tapping the bookmark icon",

  "activity.title": "Activity",
  "activity.empty": "No activity yet",
  "activity.emptyHint": "When someone likes, replies, or follows you, it'll show up here.",
  "activity.emptyFiltered": "No activity in this category yet",
  "activity.today": "Today",
  "activity.thisWeek": "This Week",
  "activity.earlier": "Earlier",
  "activity.filter.all": "All",
  "activity.filter.follows": "Follows",
  "activity.filter.replies": "Replies",
  "activity.filter.mentions": "Mentions",
  "activity.filter.reposts": "Reposts",
  "activity.followedYou": "followed you",
  "activity.likedYourPost": "liked your post",
  "activity.repliedToYourPost": "replied to your post",
  "activity.mentionedYou": "mentioned you",
  "activity.repostedYourPost": "reposted your post",
  "activity.tippedYou": "sent you a tip",

  "settings.mutedWords": "Muted Words",
  "settings.mutedWordsHint": "Posts containing muted words will be hidden",
  "settings.addWordPlaceholder": "Add a word or phrase...",
  "settings.noMutedWords": "No muted words yet",
  "settings.moderation": "Content Moderation",
  "settings.accessibility": "Accessibility",

  "onboarding.welcome": "Welcome to Scroll",
  "onboarding.selectInterests": "Select your interests",
  "onboarding.suggestedFollows": "Suggested creators",
  "onboarding.done": "You're all set!",
  "onboarding.skip": "Skip",
  "onboarding.next": "Next",
  "onboarding.finish": "Start Scrolling",

  "error.somethingWentWrong": "Something went wrong",
  "error.unexpectedError": "An unexpected error occurred",
  "error.tryAgain": "Try Again"
}
